const isFunction = input => typeof input === 'function';
export default isFunction;